module.exports = __webpack_public_path__ + "52e22705df5aaaa00f26ca8b4fbc1cbc.png";